export const APP_SECTIONS = ['onboarding', 'builder', 'analytics', 'settings', 'notifications', 'subscriptions', 'backup'];

export const BUILDER_TABS = [
  'metadata', 'pois', 'edit-poi', 'map', 'museum-info', 'venue-page',
  'ai-guide-content', 'media-package', 'quality-review',
  'audio', 'translation', 'story-ai', 'rag', 'objects', 'room-recognition', 'vpr',
];

export const normalizeAppSection = (value) => (
  APP_SECTIONS.includes(String(value || '')) ? String(value) : 'builder'
);

export const normalizeBuilderTab = (value) => (
  BUILDER_TABS.includes(String(value || '')) ? String(value) : 'metadata'
);

export const readWorkspaceUrlState = (href = window.location.href) => {
  const url = new URL(href);
  return {
    section: normalizeAppSection(url.searchParams.get('section')),
    tab: normalizeBuilderTab(url.searchParams.get('tab')),
    guideUrl: url.searchParams.get('loadGuideUrl') || '',
    guideId: url.searchParams.get('loadGuideId') || '',
  };
};

export const buildWorkspaceUrl = (href, changes = {}) => {
  const url = new URL(href);
  const setOrDelete = (key, value) => {
    if (value === null || value === undefined || value === '') url.searchParams.delete(key);
    else url.searchParams.set(key, String(value));
  };

  if (Object.prototype.hasOwnProperty.call(changes, 'section')) {
    setOrDelete('section', normalizeAppSection(changes.section));
  }
  if (Object.prototype.hasOwnProperty.call(changes, 'tab')) {
    setOrDelete('tab', normalizeBuilderTab(changes.tab));
  }
  if (Object.prototype.hasOwnProperty.call(changes, 'guideUrl')) {
    setOrDelete('loadGuideUrl', changes.guideUrl);
  }
  if (Object.prototype.hasOwnProperty.call(changes, 'guideId')) {
    setOrDelete('loadGuideId', changes.guideId);
  }
  return url.toString();
};

export const replaceWorkspaceUrl = (changes) => {
  const nextUrl = buildWorkspaceUrl(window.location.href, changes);
  if (nextUrl !== window.location.href) {
    window.history.replaceState(window.history.state, '', nextUrl);
  }
  return nextUrl;
};
